import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import https from './assets/api/http.js'
import utils from './utils/utils'
import appUtils from './utils/appUtils'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueScroller from "vue-scroller"
import Vant from 'vant';
import 'vant/lib/index.css';
import 'swiper/dist/css/swiper.css'
import './assets/css/style.css'
import './assets/css/common.css'

Vue.config.productionTip = false
Vue.prototype.$api = https
Vue.prototype.$utils = utils
Vue.prototype.$appUtils = appUtils

Vue.use(VueAwesomeSwiper);
Vue.use(VueScroller);
Vue.use(Vant);

// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
// Vue.use(vConsole)

Raven.config('https://e35b1d54a7874daeb845206df49dc062@error.jiankanghao.net/56').addPlugin(RavenVue, Vue).install();

new Vue({
  router,
  render: h => h(App)
}).$mount("#app")


